import { motion } from 'framer-motion';

export const ServicesProcess = () => (
  <section className="py-24" data-testid="process-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="text-center mb-16"
      >
        <span className="inline-block px-4 py-2 bg-[#f1f5f9] rounded-full text-sm font-medium text-[#3b5998] mb-4">
          Our Process
        </span>
        <h2 className="font-heading text-3xl sm:text-4xl font-semibold text-[#0f172a] mb-4">
          D2D Model — Documentation to Disbursement
        </h2>
        <p className="text-[#64748b] max-w-2xl mx-auto">
          A streamlined approach ensuring complete support throughout your financial journey.
        </p>
      </motion.div>

      <div className="grid md:grid-cols-4 gap-8">
        {[
          { step: '01', title: 'Consultation', description: 'Understanding your requirements and financial goals' },
          { step: '02', title: 'Documentation', description: 'Comprehensive preparation of all required documents' },
          { step: '03', title: 'Processing', description: 'Submission and follow-up with relevant authorities' },
          { step: '04', title: 'Disbursement', description: 'Successful fund release and post-sanction support' }
        ].map((item, index) => (
          <motion.div
            key={item.step}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: index * 0.15 }}
            className="relative"
          >
            <div className="text-center">
              <span className="stat-number text-5xl font-semibold mb-4 block">{item.step}</span>
              <h3 className="font-heading text-xl font-semibold text-[#0f172a] mb-2">{item.title}</h3>
              <p className="text-[#64748b] text-sm">{item.description}</p>
            </div>
            {index < 3 && (
              <div className="hidden md:block absolute top-8 right-0 translate-x-1/2 w-1/2 h-0.5 bg-gradient-to-r from-[#3b5998] to-[#00bcd4]"></div>
            )}
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
